import { AxiosResponse } from "axios";
import client from "@/utils/api/client";
import {
  DefaultApiCategoriesIdSearchConditionGroupsGetRequest,
  SearchConditionGroupResponse,
} from "@/web-client";
import useSWR, { SWRResponse } from "swr";

export const getSearchConditionGroupsByCategoryId = (
  request: DefaultApiCategoriesIdSearchConditionGroupsGetRequest,
): Promise<AxiosResponse<SearchConditionGroupResponse[]>> =>
  client.categoriesIdSearchConditionGroupsGet(request);

export const useGetSearchConditionGroupsByCategoryId = (
  id: number | undefined,
): SWRResponse<SearchConditionGroupResponse[]> => {
  const response = useSWR<SearchConditionGroupResponse[]>(
    id ? `/categories/${id}/search_condition_groups` : null,
    async () => {
      const { data } = await getSearchConditionGroupsByCategoryId({ id });

      return data || [];
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return response;
};
